import { mockCdd } from '@/__mocks__';
import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initCddForm({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchQuestionnaire', individualId),
      dispatch('fetchStates'),
    ];
    await Promise.all(requests);
    dispatch('setupCdd');
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCurrentQuestionnaire({
        token,
        individualId,
      });
      commit('setQuestionnaire', response.data.questionnaire_master_data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCddEddState(token);
      commit('setStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   */
  setupCdd({ commit, getters }) {
    const questionnaire = getters.questionnaire;
    if (questionnaire.cdd) {
      commit('setCdd', JSON.parse(questionnaire.cdd));
      return;
    }
    const cdd = mockCdd();
    commit('setCdd', cdd);
    commit('setCustomer', {
      id: questionnaire.individual_id,
      fullname: questionnaire.fullname,
      address: questionnaire.address,
      city: questionnaire.city,
      province: questionnaire.province,
      state: questionnaire.state,
    });
  },
  /**
   *
   * @param {Function} commit
   * @param {String} sectionId
   * @param {String} id
   * @param {Boolean} value
   */
  saveSectionValue({ commit }, { sectionId, id, value }) {
    commit('setSectionValue', { sectionId, id, value });
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   */
  async saveCddForm({ commit, getters, rootGetters }, cddStateId) {
    commit('setSaving', true);
    const token = rootGetters['auth/token'];
    const questionnaireId = getters.questionnaire.id;
    const data = {
      cdd: JSON.stringify(getters.cdd),
      cdd_state_id: cddStateId,
    };
    try {
      await individualApi.requestAssignCdd({
        token,
        questionnaireId,
        data,
      });
      return true;
    }
    catch (error) {
      commit('setError', error);
      return false;
    }
    finally {
      commit('setSaving', false);
    }
  },
};
